import RSAA from 'redux-api-middleware/lib/RSAA';
import { get } from 'lodash';
import endpoints from '../../utils/endpoints';
import { getReference, getAmount, getScheduleDetails, getSingleDetails } from '../../helpers/apiRequestBuilder/common';
import { retailPaymentTypes } from './constants';

export const UPDATE_RETAIL_PAYMENT = 'UPDATE_RETAIL_PAYMENT';

export const SUBMIT_RETAIL_PAYMENT_REQUEST = 'SUBMIT_RETAIL_PAYMENT_REQUEST';
export const SUBMIT_RETAIL_PAYMENT_SUCCESS = 'SUBMIT_RETAIL_PAYMENT_SUCCESS';
export const SUBMIT_RETAIL_PAYMENT_FAILURE = 'SUBMIT_RETAIL_PAYMENT_FAILURE';

export const SUBMIT_REPEATING_RETAIL_PAYMENT_REQUEST = 'SUBMIT_REPEATING_RETAIL_PAYMENT_REQUEST';
export const SUBMIT_REPEATING_RETAIL_PAYMENT_SUCCESS = 'SUBMIT_REPEATING_RETAIL_PAYMENT_SUCCESS';
export const SUBMIT_REPEATING_RETAIL_PAYMENT_FAILURE = 'SUBMIT_REPEATING_RETAIL_PAYMENT_FAILURE';

export const SUBMIT_FUTURE_RETAIL_PAYMENT_REQUEST = 'SUBMIT_FUTURE_RETAIL_PAYMENT_REQUEST';
export const SUBMIT_FUTURE_RETAIL_PAYMENT_SUCCESS = 'SUBMIT_FUTURE_RETAIL_PAYMENT_SUCCESS';
export const SUBMIT_FUTURE_RETAIL_PAYMENT_FAILURE = 'SUBMIT_FUTURE_RETAIL_PAYMENT_FAILURE';

const getBeneficiaryId = (payment) => ({
	beneficiary_id: get(payment, 'beneficiary_id') || get(payment, 'toAccount'),
});

export const updateRetailPayment = (key, value) => ({
	type: UPDATE_RETAIL_PAYMENT,
	key,
	value,
});

export const getOneOffPaymentRequest = (payment) => ({
	source_id: payment.id,
	...getBeneficiaryId(payment),
	...getAmount(payment),
	...getReference(payment),
});

export const getRepeatingPaymentRequest = (payment) => {
	const result = {
		source_id: payment.id,
		...getReference(payment),
		...getBeneficiaryId(payment),
		...getScheduleDetails(payment),
	};

	return result;
};

export const getFuturePaymentRequest = (payment) => {
	const result = {
		source_id: payment.id,
		...getReference(payment),
		...getBeneficiaryId(payment),
		...getSingleDetails(payment),
	};

	return result;
};

export const submitRetailPayment = (payment) => {
	const body = JSON.stringify(getOneOffPaymentRequest(payment));
	const uri = endpoints.transaction.resolve(null, 'default', payment.from);

	return {
		[RSAA]: {
			endpoint: uri,
			method: 'POST',
			types: [SUBMIT_RETAIL_PAYMENT_REQUEST, SUBMIT_RETAIL_PAYMENT_SUCCESS, SUBMIT_RETAIL_PAYMENT_FAILURE],
			body,
			headers: { 'x-bpi-version': endpoints.transaction.x_bpi_version },
		},
	};
};

export const submitFutureRetailPayment = (payment) => {
	const body = JSON.stringify(getFuturePaymentRequest(payment));
	const uri = endpoints.mandate.resolve(null, 'default', payment.from);

	return {
		[RSAA]: {
			endpoint: uri,
			method: 'POST',
			types: [
				SUBMIT_FUTURE_RETAIL_PAYMENT_REQUEST,
				SUBMIT_FUTURE_RETAIL_PAYMENT_SUCCESS,
				SUBMIT_FUTURE_RETAIL_PAYMENT_FAILURE,
			],
			body,
			headers: { 'x-bpi-version': endpoints.transaction.x_bpi_version },
		},
	};
};

export const submitRepeatingRetailPayment = (payment) => {
	const body = JSON.stringify(getRepeatingPaymentRequest(payment));
	const uri = endpoints.mandate.resolve(null, 'default', payment.from);

	return {
		[RSAA]: {
			endpoint: uri,
			method: 'POST',
			types: [
				SUBMIT_REPEATING_RETAIL_PAYMENT_REQUEST,
				SUBMIT_REPEATING_RETAIL_PAYMENT_SUCCESS,
				SUBMIT_REPEATING_RETAIL_PAYMENT_FAILURE,
			],
			body,
			headers: { 'x-bpi-version': endpoints.mandate.x_bpi_version },
		},
	};
};

export const makePayment = (dispatch, getState) => {
	const state = getState();

	const payment = state.retailPayment;

	switch (payment.type) {
		case retailPaymentTypes.immediate:
			return dispatch(submitRetailPayment(payment)).then((response) => {
				console.log('success', response);
			});

		case retailPaymentTypes.futureDated:
			return dispatch(submitFutureRetailPayment(payment)).then((response) => {
				console.log('success', response);
			});

		case retailPaymentTypes.repeating:
			return dispatch(submitRepeatingRetailPayment(payment)).then((response) => {
				console.log('success', response);
			});

		default:
			return null;
	}
};
